module.exports = __webpack_public_path__ + "img/female.44909ecb.svg";